export interface TimePeriod {
  id?: string;
  name?: string;
}

export interface ObjectPool {
  desc: string;
  displayType?: string;
  entries?: string[] | Record<string, string | number>[];
  id: string | undefined;
  name: string;
  named_entries?: NamedEntry[] | YoutubeNamedEntry[];
  type: number;
}

export interface NamedEntry {
  click_action: string;
  desc: string;
  invalidValueMsg: string | null;
  name: string;
  value: string;
  id: string | number | undefined;
}

export enum YoutubeNamedEntryType {
  Video = 0,
  Channel = 1,
  Category = 2,
}

/**
 * A YoutubeNamedEntry extends NamedEntry with an additional `type` field to indicate Channel, Category, or Video.
 *
 * For a YoutubeNamedEntry of type Channel,
 * - `id` is the resolved channel ID
 * - `name` is the resolved channel name
 * - `desc` is the original URL entered by the user
 * - `value` is the resolved channel ID, same as `id`
 * - `type` is YoutubeNamedEntryType.Channel, which is 1
 *
 * For a YoutubeNamedEntry of type Category,
 * - `id` is the category ID
 * - `name` is the unique category name
 * - `desc` is the unique category name, same as `name`
 * - `value` is the unique category name, same as `name`. This is because the VG extension can only send the category name to the backend, not the ID
 * - `type` is YoutubeNamedEntryType.Category, which is 2
 *
 * TODO: For a YoutubeNamedEntry of type Video,
 * - `id` is the resolved video ID
 * - `name` is the resolved video title
 * - `desc` is the original URL entered by the user
 * - `value` is the resolved video ID, same as `id`
 * - `type` is YoutubeNamedEntryType.Video, which is 0
 */
export interface YoutubeNamedEntry extends NamedEntry {
  type: YoutubeNamedEntryType;
}

export const isYoutubeNamedEntry = (entry: NamedEntry | YoutubeNamedEntry): entry is YoutubeNamedEntry => {
  return (
    (entry as YoutubeNamedEntry).type !== undefined && Object.values(YoutubeNamedEntryType).includes((entry as YoutubeNamedEntry).type)
  );
};

export const YoutubeDisplayTypeIndex = 8 as const;

export const displayTypesArray = [
  [0, "IP Range List"],
  [1, "IP Subnet List"],
  [2, "Website List"],
  [4, "MAC Address List"],
  [6, "Search Keywords"],
  [7, "Domains List"],
  [YoutubeDisplayTypeIndex, "YouTube List"],
] as const;
